import { useNavigate } from "react-router-dom";
import TariffWizard from "../../components/tariff/wizard/TariffWizard";

const CreateTariffPage = () => {
    const navigate = useNavigate();
    return <TariffWizard mode="create" onCancel={() => navigate("/tariffs")} />;
};

export default CreateTariffPage;
